import React from 'react';
import * as THREE from 'three';
import { useGLTF } from '@react-three/drei';
import { GroupProps, useThree } from '@react-three/fiber';
import shampooGltf from '../../../../../../static/gltf/Shampoo/Shampoo_threejs-opt.glb';

const MODEL_URL = shampooGltf;

function Shampoo(props: GroupProps) {
    const { nodes } = useGLTF(MODEL_URL, true) as any;
    const scaleVec = Array.isArray(props.scale) ? new THREE.Vector3().fromArray(props.scale) : new THREE.Vector3(1);
    scaleVec.multiplyScalar(0.7);
    const renderer = useThree((state) => state.gl);

    nodes.Cube.material.map.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());
    nodes.Cube_1.material.map.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());

    return (
        <group {...props} dispose={null} scale={scaleVec}>
            <mesh geometry={nodes.Cube.geometry} material={nodes.Cube.material} position={[0, 0, 0.001]} />
            <mesh geometry={nodes.Cube_1.geometry} material={nodes.Cube_1.material} position={[0, 0, 0.001]} />
        </group>
    );
}

export default Shampoo;
